/**
 * Green Flag — PreSparkPrompt
 *
 * The "Spark before you go" pitch: a heart, the heading and one line on why.
 * The /events UpcomingRegistrationWidget adds its own Start Sparking button.
 * (The event page's SpotSavedWidget carries the same pitch in its panel.)
 * Never says how many people are going.
 */

import { Box, Flex, FlexProps, Text } from "@chakra-ui/react";
import { Icon } from "../Icon/Icon";

export function PreSparkPrompt(flexProps: FlexProps) {
  return (
    <Flex gap="0.75rem" align="center" {...flexProps}>
      <Flex
        boxSize="2.5rem"
        borderRadius="full"
        bg="bg.brandSoft"
        color="greenLight.fg"
        align="center"
        justify="center"
        flexShrink={0}
      >
        <Icon name="heart" boxSize="18px" />
      </Flex>
      <Box>
        <Text textStyle="labelStrong" color="fg.onTint">
          Spark before you go
        </Text>
        <Text textStyle="bodySecondary" color="fg.onTint" mt="0.125rem">
          Get a feel for who you might meet before you walk in.
        </Text>
      </Box>
    </Flex>
  );
}
